module.exports = __webpack_public_path__ + "static/media/bookmarks.a76c2cf8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/bookmarks.svg
// module id = ./src/assets/media/forum/bookmarks.svg
// module chunks = 16